import { jsx } from "panel";
import { SegmentFilterEl } from "common/charts/misc/segment-filter";
import { InsightsLineChartEl } from "common/report/insights/charts/insights-line-chart";
import { InsightsPieChartEl } from "common/report/insights/charts/insights-pie-chart";
import { InsightsMetricChartEl } from "common/report/insights/charts/insights-metric-chart";
import { InsightsBarChartEl } from "common/report/insights/charts/insights-bar-chart";
import { InsightsTableChartEl } from "common/report/insights/charts/insights-table-chart";
import { FunnelsStepChartEl } from "common/report/funnels/charts/funnels-step-chart";
import { FunnelStepBookmarkType } from "common/report/funnels/charts/funnels-step-chart/types";
export function template() {
  const { report } = this.state;
  const downloadDisplayPreferences = this.helpers.getDownloadDisplayPreferences();
  const bookmarkParams = report.toBookmarkData();
  return /* @__PURE__ */ jsx("div", {
    sel: ".chart",
    class: {
      "resizing-layout": this.attr(`resizing-layout`),
      "download-mode": this.helpers.isDownloadMode()
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".main-chart"
  }, this.helpers.isBarChart() ? /* @__PURE__ */ jsx("div", {
    sel: ".common-bar-chart-container"
  }, /* @__PURE__ */ jsx(InsightsBarChartEl, {
    attrs: {
      "enable-sort": true,
      "download-mode": this.helpers.isDownloadMode(),
      elref: `barChart`
    },
    props: {
      paramsAndResults: {
        params: bookmarkParams,
        results: this.queryResults
      },
      barPopoverCallback: this.tablePopoverCallback,
      legendUrlData: report.legend.getDeprecatedUrlData()
    },
    on: {
      columnWidthChange: (ev) => this.helpers.updateBarColumnWidths(ev.detail.columnWidths),
      sortingChange: (ev) => this.helpers.updateBarSortConfig(ev.detail.sortConfig),
      barPopoverAction: (ev) => this.handleTablePopoverAction(ev.detail)
    }
  }), !this.helpers.isDownloadMode() && /* @__PURE__ */ jsx(SegmentFilterEl, {
    sel: ".segment-filter",
    on: {
      "export-csv": this.helpers.handleExportCsv
    }
  })) : this.helpers.isLineChart() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".common-line-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".common-line-chart-container",
    class: { "fixed-size-chart": this.getContext(`reportLayoutManager`).hasFixedSizeChart() }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".chart-area"
  }, /* @__PURE__ */ jsx(InsightsLineChartEl, {
    sel: ".line-chart",
    attrs: {
      loaded: true,
      "show-annotations": !this.helpers.isDownloadMode(),
      elref: `insightsLineChart`
    },
    props: {
      paramsAndResults: {
        params: bookmarkParams,
        results: this.queryResults
      },
      urlLegendData: report.legend.getDeprecatedUrlData(),
      popoverCallback: this.helpers.lineChartPopoverCallback
    },
    on: {
      popoverAction: this.helpers.handleLineChartPopoverAction
    }
  })))), downloadDisplayPreferences.isDownloadTruncated && /* @__PURE__ */ jsx("div", {
    sel: ".truncated-data-download-text"
  }, "Results have been truncated to the first 12 results for export.")) : this.helpers.isPieChart() ? /* @__PURE__ */ jsx("div", {
    sel: ".common-pie-container",
    class: { "fixed-size-chart": this.getContext(`reportLayoutManager`).hasFixedSizeChart() }
  }, /* @__PURE__ */ jsx(InsightsPieChartEl, {
    sel: ".pie-chart",
    attrs: {
      loaded: true
    },
    props: {
      paramsAndResults: {
        params: bookmarkParams,
        results: this.queryResults
      },
      urlLegendData: report.legend.getDeprecatedUrlData(),
      popoverCallback: this.helpers.pieChartPopoverCallback
    },
    on: {
      popoverAction: this.helpers.handlePieChartPopoverAction
    }
  })) : this.helpers.isTableChart() ? /* @__PURE__ */ jsx(InsightsTableChartEl, {
    params: {
      bookmarkParams,
      results: this.queryResults,
      resizingLayout: true,
      enablePivotView: this.attr(`enable-pivot-view`),
      canUseViewN: this.attr(`can-use-view-n`),
      downloadMode: this.helpers.isDownloadMode(),
      popoverCallback: this.tablePopoverCallback,
      popoverActionCallback: this.handleTablePopoverAction,
      sortChangeCallback: this.helpers.dataTableSortChange,
      columnWidthOverrides: this.tableChartColumnWidthOverrides,
      columnResizeCallback: this.helpers.dataTableColumnResize
    }
  }) : this.helpers.isMetricChart() ? /* @__PURE__ */ jsx("div", {
    sel: ".metric-container"
  }, /* @__PURE__ */ jsx(InsightsMetricChartEl, {
    props: {
      paramsAndResults: {
        params: bookmarkParams,
        results: this.queryResults
      },
      urlLegendData: report.legend.getDeprecatedUrlData(),
      popoverCallback: this.helpers.metricChartPopoverCallback
    },
    on: {
      popoverAction: this.helpers.handleMetricChartPopoverAction
    },
    class: {
      "fixed-size-chart": this.getContext(`reportLayoutManager`).hasFixedSizeChart()
    }
  })) : this.helpers.isFunnelStepsChart() ? /* @__PURE__ */ jsx("div", {
    sel: ".step-chart-container",
    class: {
      "fixed-size-chart": this.getContext(`reportLayoutManager`).hasFixedSizeChart()
    }
  }, /* @__PURE__ */ jsx(FunnelsStepChartEl, {
    sel: ".funnels-step-chart",
    attrs: {
      loaded: true,
      "enable-segment-click": true,
      "min-step-width": 266,
      "max-step-width": 600,
      "resizing-layout": this.attr(`resizing-layout`),
      "show-popover": true
    },
    class: {
      "resizing-layout": this.attr(`resizing-layout`)
    },
    props: {
      bookmarkData: {
        queryResults: this.queryResults,
        bookmark: bookmarkParams,
        type: FunnelStepBookmarkType.MULTIMETRIC
      },
      popoverCallback: this.helpers.stepsChartPopoverCallback
    },
    on: {}
  })) : null));
}
